import posthog from 'posthog-js';
import { StepStatus } from '~/enums';

/**
 * Durable telemetry for the Auth0 authentication flow.
 *
 * Mirrors the svc-onboarding auth flow convention (one event discriminated by
 * stepName + stepStatus, reusing the shared StepStatus enum) so the Auth0 flow
 * charts with the same funnel/time-to-convert tiles. The returnTo properties on
 * each event capture where the user was headed versus where they were sent.
 */
export const AUTH0_AUTH_EVENT = 'auth0_authentication';

export type Auth0StepName =
  | 'interactive_login'
  | 'silent_reauth'
  | 'on_redirect_callback'
  | 'session_authenticated';

interface CaptureAuth0AuthFlowParams {
  stepName: Auth0StepName;
  stepStatus: StepStatus;
  properties?: Record<string, unknown>;
  // send_instantly flushes before a full-page redirect so the event is not lost
  sendInstantly?: boolean;
}

export const captureAuth0AuthStep = ({
  stepName,
  stepStatus,
  properties,
  sendInstantly,
}: CaptureAuth0AuthFlowParams) => {
  const eventProperties = { stepName, stepStatus, ...properties };

  // Mirror trackStandaloneActions: feed the Cypress double so e2e specs can
  // assert on auth telemetry the same way they do for the svc-onboarding flow.
  if (window.Cypress) {
    window.posthogCapture(AUTH0_AUTH_EVENT, eventProperties);
  }

  posthog.capture(
    AUTH0_AUTH_EVENT,
    eventProperties,
    sendInstantly ? { send_instantly: true } : undefined
  );
};
